import React from 'react';
import PropTypes from 'prop-types';

import SplitsList from './SplitsList';
import tipSplitsColumns from './tipSplitsColumns';
import SimpleHeader from '../../../main/headers/simpleHeader';
import Tabs from '../../../admin/shops/components/ShopListTabs';
import commissionSplitsColumns from './commissionSplitsColumns';

const CommissionSplitsList = ({ tipSplitsShops, commissionSplitsShops }) => (
  <div>
    <SimpleHeader heading="Commission/Tip Splits" />
    <div className="c-wrapper o-page-height">
      <Tabs>
        <div label="Commission Splits">
          <SplitsList shops={commissionSplitsShops} columns={commissionSplitsColumns} />
        </div>
        <div label="Tip Splits">
          <SplitsList shops={tipSplitsShops} columns={tipSplitsColumns} />
        </div>
      </Tabs>
    </div>
  </div>
);

CommissionSplitsList.propTypes = {
  tipSplitsShops: PropTypes.array,
  commissionSplitsShops: PropTypes.array,
};

CommissionSplitsList.defaultProps = {
  tipSplitsShops: [],
  commissionSplitsShops: [],
};

export default CommissionSplitsList;
